// extracted by mini-css-extract-plugin
export default {"completedDot":"completedDot--GIsQU"};